import { css } from 'styled-components';

export const styledFonts = css`
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url('https://fonts.gstatic.com/s/lato/v17/S6uyw4BMUTPHjx4wXg.woff2') format('woff2');
  }
`;